import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=c0f14d5e&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f14d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f14d5e')) {
      api.createRecord('c0f14d5e', component.options)
    } else {
      api.reload('c0f14d5e', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=c0f14d5e&scoped=true&", function () {
      api.rerender('c0f14d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4B60lnwoq7AQO/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports